import {
  usePlanCancel,
  usePlanCreate,
  usePlanDelete,
  usePlanGet,
  usePlanGetSuspense,
  usePlanRevival,
} from "@/api/generated/endpoints/api"
import { planCancelBody, planCreateBody, planGetParams } from "@/api/generated/schemas/api.zod"

export * as PlanModels from "./models"

export const planApi = {
  // Query Hooks
  usePlanGet,
  usePlanGetSuspense,

  // Mutation Hooks
  usePlanCreate,
  usePlanCancel,
  usePlanRevival,
  usePlanDelete,
}

export const planSchemas = {
  planCreateBody,
  planCancelBody,
  planGetParams,
}
